<template>
  <v-content>
    <v-container>
      <v-card>
        <v-card-title>
          <router-link to="/app/orders/view">
            <span style="font-size: 12px; position: absolute">
              <v-icon>mdi-arrow-left-circle</v-icon>
              Go back
            </span>
          </router-link>
          <h3 class="mx-auto">
            Order <span v-if="order !== null">{{order.name}}</span>
          </h3>
        </v-card-title>
        <v-card-text v-if="order !== null">
          <table class="mx-auto">
            <tr>
              <td>Order Number</td>
              <td colspan="2">{{order.name}}</td>
            </tr>
            <tr>
              <td>Customer Name</td>
              <td colspan="2">{{order.customer.first_name}} {{order.customer.last_name}}</td>
            </tr>
            <tr>
              <td>Customer Contanct</td>
              <td colspan="2">
                <span v-if="order.customer.email !== null">{{order.customer.email}}</span>
                <span v-if="order.customer.email !== null && order.customer.phone !== null">, <br></span>
                <span v-if="order.customer.phone !== null">{{order.customer.phone}}</span>
              </td>
            </tr>
            <tr v-for="(item, i) in order.line_items" :key="i">
              <td :rowspan="order.line_items.length" v-if="i === 0">Items</td>
              <td style="font-weight: normal">
                <p><strong>Title:</strong> {{item.title}}</p>
                <p><strong>Description:</strong> {{item.name}}</p>
                <p v-if="item.order_uid"><strong>Order UID:</strong> {{item.order_uid}}</p>
                <p><strong>SKU:</strong> {{item.sku}}</p>
                <p><strong>Quantity:</strong> {{item.quantity}}</p>
                <p><strong>Price:</strong> <v-icon style="font-size: 16px">mdi-currency-inr</v-icon>{{item.price}}</p>
              </td>
            </tr>
            <tr>
              <td>Shipping Name</td>
              <td colspan="2">{{order.shipping_address.name}}</td>
            </tr>
            <tr>
              <td>Shipping Contact</td>
              <td colspan="2">{{order.shipping_address.phone}}</td>
            </tr>
            <tr>
              <td>Shipping Address</td>
              <td colspan="2">{{order.shipping_address.address1}} <br> {{order.shipping_address.address2}}</td>
            </tr>
            <tr>
              <td>Shipping City</td>
              <td colspan="2">{{order.shipping_address.city}}</td>
            </tr>
            <tr>
              <td>Shipping State</td>
              <td colspan="2">{{order.shipping_address.province}}</td>
            </tr>
            <tr>
              <td>Shipping Pincode</td>
              <td colspan="2">{{order.shipping_address.zip}}</td>
            </tr>
          </table>
        </v-card-text>
      </v-card>
    </v-container>
  </v-content>
</template>

<script>
export default {
  data() {
    return {
      order: null,
      loading: false,
    };
  },
  filters: {
    orderDateTime: (value) => {
      const d = new Date(value);
      return `${String(d.getDate()).padStart(2, 0)}/${String(d.getMonth() + 1).padStart(2, 0)}/${d.getFullYear()} ${String(d.getHours()).padStart(0, 2)}:${String(d.getMinutes()).padStart(2, 0)}`;
    },
  },
  methods: {
    async getOrder() {
      // Fetch ASOs here
      // console.log(this.$route.params.orderId);
      const orderQuery = await this.firebase.firestore().collection('orders').where('id', '==', parseInt(this.$route.params.orderId, 10)).get();
      if (orderQuery.size > 0) {
        this.order = { uid: orderQuery.docs[0].id, ...await orderQuery.docs[0].data() };
      }
    },
  },
  computed: {
    accentColor() {
      return this.$vuetify.theme.themes.light.accent;
    },
  },
  beforeMount() {
    this.getOrder();
  },
};
</script>

<style scoped>

table, th, td {
  border: 2px solid rgba(0,0,0,0.6);
  border-collapse: collapse;
  color: black;
}
td, th {
  padding: 10px 15px;
}
tr td:first-child{
  font-weight: 500;
}
p{
  margin: 0;
}
</style>
